import React, { useState } from 'react';
import { useLingui } from '@lingui/react/macro';

import Filters from '@rover/icons/svg/filters.svg';
import { Box } from '@rover/kibble/core';
import ButtonWithCountBadge from '@rover/kibble/official-patterns/ButtonWithCountBadge';

import BooleanFiltersModal from './BooleanFiltersModal';

export type Props = {
  count: number;
};

const BooleanFilters = ({ count }: Props): JSX.Element => {
  const { t } = useLingui();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = (): void => {
    setIsModalOpen(true);
  };

  const handleCloseModal = (): void => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Box flexShrink="0">
        <ButtonWithCountBadge
          icon={Filters}
          onClick={handleOpenModal}
          badgeCount={count}
          ariaLabel={count > 0 ? t`Filters (${count} selected)` : t`Filters`}
          testID="boolean-filters-button"
          badgeTestID="boolean-filters-badge"
          circular
        />
      </Box>
      <BooleanFiltersModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default BooleanFilters;
